import React from 'react';
import { Link, Outlet } from 'react-router-dom';

const ETL = () => {
  return (
    <div className="row">
    <div className="col-12">
      <div className="card my-4">
      
      <div className="card-body px-0 pb-2">
        <div className=" p-3">
        <Link  to="./names" className='btn btn-info m-2'> Proccess Names Formla   </Link>
        <Link  to="./Cities" className='btn btn-warning m-2'> Proccess City Error    </Link>
        <Link  to="./load" className='btn btn-primary m-2'> load to datawareHouse    </Link>

        </div> 
      
        
        </div>
       <Outlet/>
        </div>
        </div>
        </div> 
  );
};

export default ETL;